import React from "react";

const ProgressBar = ({ current, total, className = "" }) => {
  const percentage = (current / total) * 100;

  return (
    <div className={`w-full bg-gray-200 rounded-full h-2.5 ${className}`}>
      <div
        className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
        style={{ width: `${percentage}%` }}
      ></div>
      <div className="text-sm text-gray-600 mt-2 text-center">
        Вопрос {current} из {total} ({Math.round(percentage)}%)
      </div>
    </div>
  );
};

export default ProgressBar;